import React, { FunctionComponent, useEffect } from 'react';
import { SEOHeaderTags } from 'components/SEO/SEOHeaderTags';
import { EventModel } from 'features/events/EventModel';
import { cloudflareUrl } from 'utilities/cloudflareImageResizer';
import { useSelector } from 'react-redux';
import { RootState } from 'rootReducer';
import { formatNumber } from 'utilities/formatters';

interface EventHeaderTagsProps {
  event: EventModel | null;
}

export const EventHeaderTags: FunctionComponent<EventHeaderTagsProps> = ({
  event
}) => {
  const hasNewComments = useSelector(
    (state: RootState) => state.chat.hasNewComments
  );
  const newCommentCount = useSelector(
    (state: RootState) => state.chat.newCommentCount
  );

  useEffect(
    function showBrowserTabCount() {
      if (!event) return;
      if (hasNewComments && newCommentCount > 0) {
        document.title = `(${formatNumber(newCommentCount)}) ${event.title}`;
      } else {
        document.title = event.title;
      }
    },
    [hasNewComments, newCommentCount, event]
  );

  if (!event) {
    return null;
  }

  const imgUrl = cloudflareUrl(event.artworkKey, {
    width: 800,
    quality: 80
  });

  return (
    <SEOHeaderTags
      title={event.title}
      description={event.description || ''}
      image={imgUrl}
      url={window.location.href}
    />
  );
};
